import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import Style from "@/components/PartsViewer/v2/ReplacementParts/index.module.scss"
import PropTypes from "prop-types"

const ReplacementParts = props => {
  const {
    productNumber,
    setProductNumber,
    partController,
    selectedFile,
    productId,
  } = props
  const [item, setItem] = useState(null)
  const { t } = useTranslation("common")
  const { viewreplacement, replacing, partname, partnumber, replacedby } =
    getTranslations(t)
  const replacePartId = productNumber?.replaceId

  useEffect(() => {
    if (replacePartId) {
      getFileNameUpdate(replacePartId)
    }
  }, [replacePartId])

  const getFileNameUpdate = async id => {
    const entry = partController.actions.get.entryByKey(id, selectedFile)
    const data = await entry.ctApiPromise
    setItem(data)
  }

  const replaceHandler = arg => {
    setProductNumber(prevState => {
      return {
        productId: replacePartId,
        replaceId: productNumber?.productId,
      }
    })
  }
  return (
    <div className={Style.ReplacementSection}>
      <div className="replacement-container">
        {replacePartId === productId ? (
          <button
            className="view-replacement"
            onClick={() => replaceHandler(productNumber)}
          >
            {viewreplacement}
          </button>
        ) : null}
        <p className="repl-heading">
          <span> {replacePartId === productId ? replacedby : replacing} </span>
        </p>
        <div className="replacement-list">
          <div className="repl-head item-text">
            <p className="repl-text">{partnumber}</p>
            <p className="repl-text">{partname}</p>
          </div>
          <div className="repl-content item-text">
            <button
              className=" repl-text link-button"
              onClick={() => replaceHandler(productNumber)}
            >
              <p className=" repl-text">{item?.Cod}</p>
              <p className=" repl-text replace-title">{item?.Name}</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ReplacementParts.propTypes = {
  productId: PropTypes.string.isRequired,
  productNumber: PropTypes.object.isRequired,
  setProductNumber: PropTypes.func.isRequired,
  partController: PropTypes.object.isRequired,
  selectedFile: PropTypes.object.isRequired,
}

export default ReplacementParts
